/* eslint-disable import/no-cycle */
/* eslint-disable import/prefer-default-export */
import { createPromiseRequest } from './util/createPromiseRequest';
import { hasAccessToken } from '../../../utils/token';
import { createTableItemAndKey, sortBySortEpoch } from './util/linesaggs';

/**
 * helper
 */
const _createPayload = (data) => { 
	const url = '/lines';
  return {
    url,
    method: 'POST',
    data
  };
}

/**
 * FETCH LINES
 */
const BATCH_SIZE = 2000;

const _fetchLinesAggs = async (customerName) => {
	if (hasAccessToken()) {
    const payloadCnt = _createPayload({ customer: customerName, returnType: 'count' });
    const fetchCnt = createPromiseRequest(payloadCnt);
    
    const { count } = await fetchCnt();
    const batchCount = Math.ceil(count / BATCH_SIZE);
    const offsets = [];
    for (let i = 0; i < batchCount; i += 1) {
      offsets.push(i * BATCH_SIZE);
    }
    
    const responses = await Promise.all(offsets.map(offset => { 
      const payload = _createPayload({ customer: customerName, returnType: 'list', limit: BATCH_SIZE, offset });
      const fetchBatch = createPromiseRequest(payload);
      return fetchBatch();
    }))

    return responses.flat().map(i => createTableItemAndKey(i)).sort(sortBySortEpoch);    
	}
	return Promise.reject(new Error('Missing Token'));
}

/**
 * MAIN
 */
export const fetchLinesAggs = async (customerName) => {
  if (!customerName) { 
    throw new Error('fetchLinesAggs missing parameter: customerName');
  }

  return _fetchLinesAggs(customerName);
};

